export default __webpack_public_path__ + "static/media/dental-icon.27c78499.svg";